<template>
  <div>
    <div class="flex h-[calc(100vh-40px)] realtive bg-[#0E0E0E]">
      <!-- left -->
      <div class="flex-[15] px-3 pb-6 flex flex-col justify-between">
        <div class="">
          <div v-for="menu in menus" :key="menu.type" class="flex items-center">
            <div
              class="h-15 w-full px-5 py-3 mb-2.5 rounded-lg hover:bg-black-active flex items-center text-white"
              :class="{
                'bg-black-active': activeMenu === menu.type
              }"
              @click="
                () => {
                  inputSearchValue = '';
                  activeMenu = menu.type;
                }
              "
            >
              <Icon
                :icon="activeMenu == menu.type ? menu.iconActive : menu.icon"
                fill="none"
                class="mr-5"
              />
              <span
                class="text-xl font-thin opacity-70"
                :class="{
                  '!font-medium !opacity-100': activeMenu == menu.type
                }"
              >
                {{ menu.title }}
              </span>
            </div>
            <a-popover
              :visible="showSamplesBubble && menu.type === 'sample'"
              placement="right"
              ><div />
              <template #content>
                <div class="flex items-center gap-1">
                  <span>表盘样例收进这里啦</span>
                </div>
              </template>
            </a-popover>
          </div>
        </div>
        <div class="flex flex-col items-center py-5">
          <a-button type="primary" class="mb-5" size="large" @click="create"
            >新建</a-button
          >
          <a-button
            size="large"
            @click="() => pickThenOpen()"
            @focus="(e:UIEvent)=>{(e.target as HTMLElement).blur();}"
          >
            打开
          </a-button>

          <export-button v-if="GlobalConfig.exportWatchfaceFromMainPage" />

          <!-- 加载本地表盘 -->
          <load-watchface-button v-if="isDev" />
        </div>
      </div>

      <!-- right -->
      <div class="flex-[85] h-full bg-[#1E1E1E] rounded-t-2xl">
        <div class="flex items-center">
          <div class="flex flex-1">
            <div
              class="search w-56 mx-5 my-2.5 px-2.5 py-3 bg-[#2C2C2C] inline-flex items-center rounded-lg"
            >
              <Icon
                :width="20"
                :height="20"
                class="mr-2"
                icon="search.svg"
                fill="transparent"
              />
              <a-input
                v-model:value="inputSearchValue"
                :bordered="false"
                class="font-bold p-0"
                placeholder="关键字搜索"
              >
                <template #suffix>
                  <Icon
                    v-if="inputSearchValue.length"
                    :width="14"
                    :height="14"
                    class="mr-2"
                    icon="add3.svg"
                    fill="transparent"
                    @click="
                      () => {
                        inputSearchValue = '';
                      }
                    "
                  />
                </template>
              </a-input>
            </div>
          </div>
          <a-popover
            placement="bottomRight"
            :visible="filterVisible"
            overlay-class-name="popClass"
          >
            <template #content>
              <modal-select-shape
                @finish-select="(selected: string[])=>([filterSelected, filterVisible] = [selected, false])"
              />
            </template>
            <div
              class="bg-black-[#5f5f5f] cursor-pointer mr-5 flex items-center"
              :class="{ 'text-[#FFA552]': filterSelected.length }"
              @click.stop="onFilterClick"
            >
              <span class="mr-1">筛选</span>
              <div>
                <icon
                  :icon="'choose.svg'"
                  :width="20"
                  :height="20"
                  :fill="filterSelected.length ? '#FFA552' : 'none'"
                />
              </div>
            </div>
          </a-popover>
        </div>

        <div
          ref="watchfaceContainer"
          class="h-[calc(100vh-106px)] overflow-y-auto"
        >
          <!-- 表盘样例 -->
          <div
            v-if="
              (activeMenu === 'lasted' && showSamples) || activeMenu == 'sample'
            "
          >
            <watchface-samples
              :active-menu="activeMenu"
              @hide="onSamplesHide"
            />
          </div>
          <!-- 表盘信息 -->
          <template v-if="activeMenu == 'info'">
            <watchface-info />
          </template>
          <!-- 历史表盘 -->
          <template v-if="activeMenu != 'sample' && activeMenu != 'info'">
            <watchface-history
              :input-search-value="inputSearchValue"
              :active-menu="activeMenu"
              :filter-selected="filterSelected"
              @update="updateWatchface"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onActivated, ref } from 'vue';
import { useWatchfaceManage } from '@/hooks';
import { onBeforeRouteLeave } from 'vue-router';
import { useStorage } from '@vueuse/core';
import { EventType, emitter } from '@/utils/emitter.utils';
import { GlobalConfig } from '@/services/gloabl.config';

const isDev = import.meta.env.DEV;

const { pickThenOpen } = useWatchfaceManage();
const menus: {
  title: string;
  type: 'lasted' | 'collect' | 'sample' | 'info';
  icon: string;
  iconActive: string;
}[] = [
  {
    title: '最近打开',
    type: 'lasted',
    icon: 'folder-library.svg',
    iconActive: 'folder-library2.svg'
  },
  {
    title: '我的收藏',
    type: 'collect',
    icon: 'favourite.svg',
    iconActive: 'favourite2.svg'
  },
  {
    title: '表盘样例',
    type: 'sample',
    icon: 'star.svg',
    iconActive: 'star2.svg'
  },
  ...((import.meta.env.DEV
    ? [
        {
          title: '表盘信息',
          type: 'info',
          icon: 'watch.svg',
          iconActive: 'watch2.svg'
        }
      ]
    : []) as typeof menus)
];
const activeMenu = ref<(typeof menus)[0]['type']>('lasted');

const editWatchfacePath = ref<string>();
const create = () => {
  emitter.emit(EventType['modal:watchface-manage'], { mode: 'create' });
};
const updateWatchface = (path: string) => {
  editWatchfacePath.value = path;
  emitter.emit(EventType['modal:watchface-manage'], { mode: 'edit', path });
};

const onFilterClick = () => {
  const visible = !filterSelected.value.length;
  filterSelected.value = [];
  filterVisible.value = visible;
};

// let flag = ref(0);
let inputSearchValue = ref('');

const filterVisible = ref(false);
const filterSelected = ref<string[]>([]);

//添加点击关闭
document.addEventListener('click', () => {
  if (filterVisible.value) filterVisible.value = false;
});

// 回到页面页面时，记录滚动位置
const watchfaceContainer = ref<HTMLDivElement>();
const screenTop = ref(0);
onActivated(() => {
  watchfaceContainer.value?.scrollTo(0, screenTop.value);
});
onBeforeRouteLeave(() => {
  const val = watchfaceContainer.value?.scrollTop ?? 0;
  screenTop.value = val;
});

// 是否展示表盘样例
// 最近打开 显示表盘样例
const showSamples = useStorage('home-show-samples', true);
const showSamplesBubble = ref(false);
const onSamplesHide = () => {
  showSamplesBubble.value = true;
  showSamples.value = false;
  setTimeout(() => (showSamplesBubble.value = false), 1000);
};
</script>

<style scoped lang="less">
.search {
  :deep(.ant-input) {
    font-size: 16px;
    line-height: 20px !important;
    font-weight: 400;
    height: 20px;
  }
  .ant-input-affix-wrapper:before {
    display: none;
  }
}
.popClass {
  .ant-popover-inner-content {
    padding: 12px 0px;
    .ant-collapse-header {
      padding: 12px 10px !important;
    }
  }
}
</style>
